module.exports = __webpack_public_path__ + "static/media/newsletter-december-2018-food-closet.c4fbbbe8.jpg";